import { ReactNode, useCallback } from 'react';
import { Body } from './Body';
import { FileRouteTypes, Link } from '@tanstack/react-router';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { ProductSKU } from 'jigsaw';
import { ProductPageHeader } from './ProductPageHeader';

type ProductPageProps = {
  children: ReactNode;
  backRoute?: FileRouteTypes['to'];
  onBack?: () => void;
  productSKU: ProductSKU;
};

export const ProductPage = ({
  children,
  backRoute,
  onBack,
  productSKU,
}: ProductPageProps) => {
  const { isPuzzleWalletWebview } = useArcadeStoreState();

  return (
    <div className={`flex h-dvh min-h-dvh flex-col overflow-y-scroll pb-safe`}>
      <ProductPageHeader
        productSKU={productSKU}
        backRoute={backRoute}
        onBack={onBack}
      />
      <Body showFooter={!isPuzzleWalletWebview}>{children}</Body>
    </div>
  );
};
